import { Shadow } from '@genial/components';
import { BoxRadius, Spacing } from '@genial/design-tokens';
import { Box } from 'native-base';
import React from 'react';

import { CustomerTableProps } from '../models';
import { TableItemList } from '../TableItemList';
import { ResponsiveLoadingTable } from '../TableItemList/components/LoadingTable';

import { TableHead } from './components/TableHead';

export const CustomerDesktopTable: React.FC<CustomerTableProps & { isSearch?: boolean }> = ({
  isLoading,
  isSearch,
  ...rest
}) => {
  return (
    <Box overflow={'hidden'} px={Spacing['inline.xxs']}>
      <TableHead isSearch={isSearch} isLoading={isLoading} />
      <Shadow
        level={2}
        borderRadius={BoxRadius.sm}
        testId="customer-table-list"
        mb={Spacing['inset.md']}>
        {isLoading && <ResponsiveLoadingTable />}
        {!isLoading && <TableItemList isLoading={isLoading} {...rest} />}
      </Shadow>
    </Box>
  );
};
